import React, { Component } from 'react';
import Dropdown from 'react-bootstrap/lib/Dropdown';
import MenuItem from 'react-bootstrap/lib/MenuItem';
import PropTypes from 'prop-types';
import i18n from '../../src/i18n/translate';
import Icon from './Icon';


export default class LanguageDropdown extends Component {
  static propTypes = {
    languages: PropTypes.object,
    locale: PropTypes.string,
    locales: PropTypes.array,
    reloadType: PropTypes.string
  }

  constructor(props) {
    super(props);
    let langs = [], availableLangs = [];
    if(props.languages){
      // all currently compiled languages
      Object.entries(props.languages).forEach(([key, value]) => {
        langs.push({ name: value, abbr: key });
      });
      // user's available languages from full list
      availableLangs = langs.filter(lng => props.locales.includes(lng.abbr));
    }
    this.state = {
      dropdowns: {},
      allLanguages: langs,
      availableLanguages: availableLangs
    };
  }

  onToggleDropdown = (open, event, _eventDetails) => {
    if (_eventDetails.source === 'rootClose') {
      this.setState({ dropdowns: {} });
    } else {
      this.toggleDropdown(event.currentTarget.id, open);
    }
  }

  toggleDropdown = (key, open) => {
    this.setState({ dropdowns: { [key]: open } });
  }

  setUrlParameter = (url, setkey, setvalue) => {
    const key = encodeURIComponent(setkey),
      value = encodeURIComponent(setvalue),
      baseUrl = url.split('?')[0],
      newParam = key + '=' + value;
    let params = '?' + newParam;

    let urlQueryString = (url.split('?')[1] === undefined) ? '' : '?' + url.split('?')[1];

    // If the "search" string exists, then build params from it
    if (urlQueryString) {
      const updateRegex = new RegExp('([\?&])' + key + '=[^&]*');
      const removeRegex = new RegExp('([\?&])' + key + '=[^&;]+[&;]?');

      if (!value || value === '') { // Remove param if value is empty
        params = urlQueryString.replace(removeRegex, "$1");
        params = params.replace(/[&;]$/, "");

      } else if (urlQueryString.match(updateRegex) !== null) { // If param exists already, update it
        params = urlQueryString.replace(updateRegex, "$1" + newParam);

      } else if (urlQueryString === '') { // If there are no query strings
        params = '?' + newParam;
      } else { // Otherwise, add it to end of query string
        params = urlQueryString + '&' + newParam;
      }
    }
    params = params === '?' ? '' : params;
    return baseUrl + params;
  }

  changeLanguage = (lang) => {
    if(this.props.reloadType === 'query') {
      const currentLang = this.props.locale;
      if(lang.abbr !== currentLang) {
        window.location.href = this.setUrlParameter(window.location.href, 'locale', lang.abbr);
      }
    } else if(this.props.reloadType === 'inline') {
      let loc = window.location.href.split('.net/');
      if(loc[1].split('/')[0].length === 2) {
        // we have a lang in there
        if(lang.abbr !== loc[1].split('/')[0]) {
          window.location.href =  window.location.href.replace(/\/[a-z]{2}\//, lang.abbr);
        }
      } else {
        // no lang, need to add it
        window.location.href = `${loc[0]}.net/${lang.abbr}/${loc[1]}`;
      }
    }
  }

  renderDropdownMenuItem = () => {
    return this.state.availableLanguages.map((item, subKey) => {
      const currentLang = this.props.locale;
      return (
        <MenuItem
          key={subKey}
          id={`language-menu-${subKey}`}
          onClick={() => this.changeLanguage(item)}
        >
          {item.abbr === currentLang && (
            <span className="selected-language-check" aria-hidden={true}>
              <Icon iconType="check" />
            </span>
          )}
          {i18n.t(item.name)}
        </MenuItem>
      );
    });
  }

  render() {
    return (
      <Dropdown id={`language-dropdown`} className="footer-language-dropup" onToggle={this.onToggleDropdown} open={this.state.dropdowns[`language-dropdown`]}>
        <Dropdown.Toggle noCaret={true}>
          <Icon fontFamily="fa" iconType="language" />
          <span>{i18n.t('Language')}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu className="footer-language-dropup-menu">
          <div className="mobile-close" aria-label={i18n.t("Close")} onClick={() => this.toggleDropdown(`language-dropdown`, false)}>&times;</div>
          {this.renderDropdownMenuItem()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

}
